<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="500"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ title }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-title class="pt-1 pb-1">
                    <span class="subtitle-2 font-weight-bold">Variante</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-1 pb-1">
                    <v-container class="pt-1 pb-1">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    ref="name"
                                    v-model="form.name"
                                    label="Nombre de variante"
                                    outlined
                                    dense
                                    :rules="[() => !!form.name || 'Es necesario ingresar un nombre']"
                                    hide-details="auto"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-title class="pt-1 pb-1">
                    <span class="subtitle-2 font-weight-bold">Opciones</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-1 pb-1">
                    <v-container class="pt-1 pb-1">
                        <v-row>
                            <v-col cols="8">
                                <v-text-field
                                    v-model="form.option_name"
                                    label="Opción"
                                    outlined
                                    dense
                                    hide-details="auto"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-btn dark 
                                    color="blue-grey"
                                    @click="handleAddOption">
                                    Agregar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>                    
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                    <v-simple-table dense height="35vh" fixed-header>
                        <thead>
                            <tr>
                                <th class="text-left">OPCION</th>
                                <th class="text-left">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in form.options" :key="item.id">
                                <td>{{ item.option_name }}</td>
                                <td>
                                    <v-btn 
                                        icon
                                        dark 
                                        color="red"
                                        class="float-right"
                                        @click="handleDeleteOption(index)">
                                        <v-icon size="16">fas fa-times-circle</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </div>
        <div class="pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="6">
                        <v-btn @click="handleCancel" 
                            block 
                            height="40" 
                            outlined 
                            color="red darken-1">
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn v-if="action == 'create'"
                            dark 
                            color="green darken-1" 
                            block 
                            height="40" 
                            @click="handleCreate">
                            Guardar
                        </v-btn>
                        <v-btn v-else
                            dark 
                            color="blue darken-1" 
                            block 
                            height="40" 
                            @click="handleUpdate">
                            Actualizar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </div>
    </v-navigation-drawer>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
    name: 'CreateUpdate',
    data () {
        return {
            title: null,
            action: null,
            drawer: false,
            form: {
                id: null,
                name: null,
                option_name:null,
                options: []
            }
        }
    },
    computed: {
        ...mapState('variants', [
            'variant_response'
        ])
    },
    methods: {
        ...mapActions('variants', [
            'store',
            'update'
        ]),
        async show (title, action, variant = null) {
            await this.clearData();
            this.title = title;
            this.action = action;
            if (variant) {
                this.setVariant(variant);
            }
            this.drawer = !this.drawer;
        },
        setVariant (variant) {
            this.form.id = variant.id;
            this.form.name = variant.name;
            this.form.options = Object.assign([], variant.options);
        },
        handleAddOption () {
            if (this.form.option_name) {
                if (!this.existOption(this.form.option_name)) {
                    let today = new Date();
                    this.form.options.push({
                        id: today.getTime(),
                        option_name: this.form.option_name.toUpperCase()
                    });
                    this.form.option_name = null;
                }
            }
        },
        clearData () {
            this.form.id = null;
            this.form.name = null;
            this.form.option_name = null;
            this.form.options = [];
            this.clearErrors();
        },
        closeForm () {
            this.clearData();
            this.drawer = false;
        },
        handleCancel () {
            this.closeForm();
        },
        async handleCreate () {
            if (!this.existErrors()) {
                await this.store(this.form);
                if (this.variant_response == 'error') {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'REGISTRO DE VARIANTE',
                        text: 'Ocurrió un error al registrar variante.'
                    });
                } else {
                    this.closeForm();
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'REGISTRO DE VARIANTE',
                        text: 'Variante registrada de forma correcta.'
                    });                    
                }
            }
        },
        async handleUpdate () {
            if (!this.existErrors()) {
                await this.update(this.form);
                if (this.variant_response == 'error') {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'ACTUALIZACIÓN DE VARIANTE',
                        text: 'Ocurrió un error al actualizar variante.'
                    });
                } else {
                    this.closeForm();
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'ACTUALIZACIÓN DE VARIANTE',
                        text: 'Variante actualizada de forma correcta.'
                    });                    
                }
            }
        },
        handleDeleteOption (index) {
            this.form.options.splice(index, 1);
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.form).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.form[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.form).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
        existOption (name) {
            let exist = false;
            this.form.options.forEach( element => {
                if (element.option_name == name.toUpperCase()) {
                    exist = true;
                }
            });

            return exist;
        }

    }
}
</script>

<style scoped>

</style>